import { Box } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import DrawerTemplate from 'v2/components/Drawer/DrawerTemplate';
import Loader from 'v2/components/Loader/Loader';
import useSnackbarContext from 'v2/components/Snackbar/useSnackbarContext';
import useDeviceDetails from 'v2/hooks/useDeviceDetails/useDeviceDetails';
import EditUserGroupsForm from './EditUserGroupsForm';

interface Props {
  deviceId: string;
}

const EditUserGroupsDrawer = ({ deviceId }: Props) => {
  const { translation } = useTranslation();
  const { showSnackbar } = useSnackbarContext();

  const {
    device,
    deviceLoading,
    locations,
    locationsLoading,
    visitorGroups,
    visitorGroupsLoading,
    assignDoorToDoorGroupOrVisitorGroup
  } = useDeviceDetails({
    translation,
    handleFetchError: (msg) => showSnackbar(msg, { severity: 'error' }),
    deviceId
  });

  const isLoading =
    deviceLoading || !device || locationsLoading || locations === undefined || visitorGroupsLoading || !visitorGroups;

  if (isLoading) {
    return (
      <DrawerTemplate
        id="edit-user-group-drawer"
        title={translation.edit_user_groups}
        primaryAction={{
          label: translation.save,
          onClick: () => {},
          loading: true,
          disabled: true,
          id: 'save-button'
        }}
        secondaryAction={{ label: translation.cancel, id: 'cancel-button' }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <Loader />
        </Box>
      </DrawerTemplate>
    );
  }

  return (
    <EditUserGroupsForm
      device={device}
      visitorGroups={visitorGroups}
      assignDoorToDoorGroupOrVisitorGroup={assignDoorToDoorGroupOrVisitorGroup}
    />
  );
};

export default EditUserGroupsDrawer;
